export enum BreadcrumbsLoaders {
  Get = 'Get'
}
